import React, { useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import logoImage from '../assets/hd-logo.png'; // ✅ Replace with correct path if needed

const NavbarContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: ${({ theme }) => theme.background};
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1000;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Logo = styled(motion.img)`
  height: 58px; // 🔼 Increased size
  width: auto;
  cursor: pointer;
  transition: transform 0.3s ease;
  align-self: center;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    height: 50px;
  }
`;

const NavLinks = styled(motion.div)`
  display: flex;
  gap: 1.5rem;

  @media (max-width: 768px) {
    display: ${({ open }) => (open ? 'flex' : 'none')};
    flex-direction: column;
    width: 100%;
    margin-top: 1rem;
    padding: 0 1rem;
    background-color: ${({ theme }) => theme.background};
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    animation: slideIn 0.3s ease-out forwards;
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(100%);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

const NavLink = styled(motion.a)`
  font-size: 1rem;
  color: ${({ theme }) => theme.color};
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s ease;
  padding: 0.5rem 1rem;

  &:hover {
    color: ${({ theme }) => theme.accent};
  }

  @media (max-width: 768px) {
    padding: 1rem;
    text-align: center;
    width: 100%;
  }
`;

const MenuToggle = styled.div`
  display: none;
  cursor: pointer;
  font-size: 1.5rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

const navLinkVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    transition: {
      delay: i * 0.2,
      duration: 1,
      repeat: Infinity,
      repeatType: 'reverse',
    },
  }),
};

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [rotate, setRotate] = useState(false);

  return (
    <NavbarContainer>
      <Logo
        src={logoImage}
        alt="Harsh Dhama Logo"
        onClick={() => setRotate(!rotate)}
        animate={{
          rotate: rotate ? 360 : 0,
          scale: rotate ? 1.1 : 1,
          opacity: 1,
          y: 0,
        }}
        transition={{ duration: 0.8 }}
        initial={{ opacity: 0, y: -50 }}
      />

      <MenuToggle onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? '✖' : '☰'}
      </MenuToggle>

      <NavLinks open={menuOpen}>
        {['Home', 'About', 'Experience', 'Skills', 'Projects', 'Contact'].map((link, i) => (
          <NavLink
            key={link}
            href={`#${link.toLowerCase()}`}
            onClick={() => setMenuOpen(false)}
            variants={navLinkVariants}
            initial="hidden"
            animate="visible"
            custom={i}
            whileHover={{ scale: 1.1, color: '#f39c12' }}
            whileTap={{ scale: 0.95 }}
          >
            {link}
          </NavLink>
        ))}
      </NavLinks>
    </NavbarContainer>
  );
};

export default Navbar;
